package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class UserSex(private val literal: String) : IEnumType {
	男("男"),
	女("女"),
	NA("NA");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "user_sex"}
	override fun getLiteral(): String {return literal}
}
